<div class="toggle-timer-container" *ngIf="!isRecording && !startAnimation" style="width: '250px'" [@fadeOut]="startAnimation ? 'void' : null" [style.opacity]="typingMode || finishedResponding ? '0' : null">
	<div class="toggle-section" fxLayout="row" [hidden]="typingMode || finishedResponding">
		<div class="toggle-option" [ngStyle]="{ 'background-color': activeScreen === 'AUDIO' ? '#A200FF' : '#200033' }" fxFlex fxLayout="row" (click)="setActiveScreen.emit(RESPONSE_TYPES.AUDIO)">
			<button  mat-button class="option-label">AUDIO</button>
		</div>
		<div class="toggle-option" [ngStyle]="{ 'background-color': activeScreen === 'VIDEO' ? '#A200FF' : '#200033' }" fxFlex fxLayout="row" (click)="setActiveScreen.emit(RESPONSE_TYPES.VIDEO)">
			<button mat-button class="option-label">VIDEO</button>
		</div>
		<div class="toggle-option" [ngStyle]="{ 'background-color': activeScreen === 'TEXT' ? '#A200FF' : '#200033' }" fxFlex fxLayout="row" (click)="setActiveScreen.emit(RESPONSE_TYPES.TEXT)">
			<button *ngIf="currentLanguage==='en'" mat-button class="option-label">TEXT</button>
			<button *ngIf="currentLanguage==='es'" mat-button class="option-label">TEXTO</button>
		</div>
	</div>
</div>

<div class="toggle-timer-container" *ngIf="isRecording && startAnimation" style="width: '90px'" [@fadeIn]="isRecording ? '*' : null">
	<div class="timer-section">
		<div fxLayout="row" class="timer-option" style="background-color: #a200ff">
			<cd-timer *ngIf="maxVideoTime; else elseBlock" [countdown]="true" [endTime]="0" [startTime]="maxVideoTime" (onStop)="timerStop.emit()" class="timer" format="ms"></cd-timer>
			<ng-template #elseBlock><cd-timer class="timer" format="ms"></cd-timer></ng-template>
		</div>
	</div>
</div>
